import { useState } from "react";
import { Container } from "react-bootstrap";
import { FaBriefcase, FaLayerGroup, FaTools } from "react-icons/fa";
import { useTranslation } from "../../i18n";
import ProfessionalTimeline from "../About/ProfessionalTimeline";
import Techstack from "../About/Techstack";
import Toolstack from "../About/Toolstack";

function HomeShowcase() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("journey");

  const tabs = [
    {
      id: "journey",
      label: t("homeShowcase.tabs.journey"),
      icon: <FaBriefcase />,
      content: <ProfessionalTimeline />,
    },
    {
      id: "skills",
      label: t("homeShowcase.tabs.skills"),
      icon: <FaLayerGroup />,
      content: <Techstack />,
    },
    {
      id: "tools",
      label: t("homeShowcase.tabs.tools"),
      icon: <FaTools />,
      content: <Toolstack />,
    },
  ];

  const currentTab = tabs.find((tab) => tab.id === activeTab) || tabs[0];

  return (
    <Container fluid className="home-showcase-section" id="professional">
      <Container>
        <div className="home-showcase-intro">
          <span>{t("homeShowcase.eyebrow")}</span>
          <h1>{t("homeShowcase.heading")}</h1>
          <p>{t("homeShowcase.subheading")}</p>
        </div>

        <div className="home-showcase-tabs" role="tablist" aria-label="Professional overview">
          {tabs.map((tab) => (
            <button
              type="button"
              key={tab.id}
              className={activeTab === tab.id ? "active" : ""}
              onClick={() => setActiveTab(tab.id)}
              role="tab"
              aria-selected={activeTab === tab.id}
              aria-controls={`home-showcase-${tab.id}`}
              id={`home-showcase-tab-${tab.id}`}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </div>

        <div
          className="home-showcase-content"
          role="tabpanel"
          id={`home-showcase-${currentTab.id}`}
          aria-labelledby={`home-showcase-tab-${currentTab.id}`}
        >
          <div className="home-showcase-panel-heading">
            <h2>{t(`homeShowcase.panels.${currentTab.id}.title`)}</h2>
            <p>{t(`homeShowcase.panels.${currentTab.id}.description`)}</p>
          </div>
          {currentTab.content}
        </div>
      </Container>
    </Container>
  );
}

export default HomeShowcase;
